import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonServiceService } from 'src/app/services/common_service/common-service.service';
import { BettingServiceService } from '../../services/betting_service/betting-service.service';

@Component({
  selector: 'app-myslip-results',
  templateUrl: './myslip-results.component.html',
  styleUrls: ['./myslip-results.component.scss'],
})
export class MyslipResultsComponent implements OnInit {
  @Input() slipid:any
  results;

  constructor(public modalController: ModalController,public bettingService:BettingServiceService,
    public common_service: CommonServiceService) { }

  ngOnInit() {
    this.bettingService.getBetslipResults(this.slipid,this.common_service.getToken()).subscribe(data=>{
      //console.log(data);
      this.results=data;
    })
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  checkKr3Color(item) {
    const colors = ['red', 'green', 'blue', 'yellow', 'black', 'purple', 'orange', 'white'];
    for (let i = 0; i < colors.length; i++) {
      const color = colors[i];
      if (item.selectionName?.toLowerCase().includes(color)) {
        return color;
      }
    }
    return 'noColor';
  }

  checkBallColor(item: any) {

    if (item.selectionNumber >= 1 && item.selectionNumber <= 40) {
      return 'yellow';
    }
  
    if (item.selectionNumber > 40 && item.selectionNumber <= 80) {
      return 'red';
    }
  
    return '';
  }

  checkBallColorLL(item: any) {
    // Normal color detection
    const colors = ['red', 'green', 'blue', 'yellow'];
    for (let color of colors) {
      if (item.selectionName?.toLowerCase().includes(color)) {
        return color;
      }
    }
    return "noColor";
  }

  showPriceTable = false;

  openPriceTable() {
    this.showPriceTable = true;
  }

  closePriceTable() {
    this.showPriceTable = false;
  }

  checkBonusBall(position: any, bonsuBall: any) {
    return position.selectionNumber == Number(bonsuBall);
  }


}
